const formatAddress = (input) => {
    const { short = false, address, unit, city, state, zip, hide_street_number = false, } = input ?? {};
    if (!address)
        return '';
    const unitString = unit && !hide_street_number ? `, ${unit}` : '';
    const addressString = hide_street_number
        ? address.replace(/^[0-9]+[ ]/, '')
        : address;
    if (short) {
        return `${addressString}${unitString}`;
    }
    const stateAndZip = [state, zip].filter(Boolean).join(' ');
    return [`${addressString}${unitString}`, city, stateAndZip]
        .filter(Boolean)
        .join(', ');
};
export default formatAddress;
